import React from "react";
import {FooterCode} from './Allcomponents';
export default function Footer() {
  return (
    <div>
      <FooterCode 
      video_link = "https://www.youtube.com/embed/vlDzYIIOYmM"
      website_link = "http://irfanofficial.ml"
      footer_txt = "Irfan Property Dealer"
    />
    </div>
  );
}
